<template>
  <div>
    <h3>В данном разделе Вы можете загрузить ежемесячные отчеты по Вашим проектам.</h3>
    <br>
    <div class="flex-row">
      <div class="flex-col">
        <Datepicker
          v-model="datepickerPeriod"
          format="{
              day: '2-digit',
              month: '2-digit',
              year: 'numeric'
            }"
          lang="ru"
          placeholder="Выбрать период"
          range
          @change="updatePeriodFromDatePicker"
        />
      </div>
      <div class="flex-col">
        <ul
          id="tabs-header"
          class="nav nav-pills"
        >
          <li class="nav-item">
            <button
              class="btn"
              :class="{ 'btn-danger': view === 'Report', 'border-danger text-danger background-transparent': view !== 'AnalyticsCommon' }"
              @click="view = 'Report'"
            >
              Тип отчёта - report
            </button>
          </li>
          <li class="nav-item">
            <button
              class="btn"
              :class="{ 'btn-danger': view === 'TmMonitoring', 'border-danger text-danger background-transparent': view !== 'AnalyticsYandex' }"
              @click="view = 'TmMonitoring'"
            >
              Тип отчёта - tm_monitoring
            </button>
          </li>
        </ul>
      </div>
    </div>
    <div
      id="tabs-body"
      class="row"
    >
      <div class="col-md-12">
        <c-box>
          <report v-if="view === 'Report'" />
          <tm-monitoring v-if="view === 'TmMonitoring'" />
        </c-box>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-datepicker-ui/lib/vuedatepickerui.css'
import '../../../../../../resources/css/vuedatepickerui.css'
import CBox from '../../../../../../resources/js/components/ui/CBox'
import Datepicker from 'vue-datepicker-ui'
import Report from '../components/reports/Report.vue'
import TmMonitoring from '../components/reports/TmMonitoring.vue'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Reports',
  components: { CBox, Datepicker, Report, TmMonitoring },
  data () {
    return {
      view: 'Report',
      datepickerPeriod: []
    }
  },
  computed: {
    ...mapGetters({
      getPeriod: 'Period/getPeriod'
    })
  },
  mounted () {
    // Инициализация периода
    this.initPeriod()
  },
  methods: {
    ...mapMutations({
      setPeriod: 'Period/setPeriod'
    }),
    initPeriod () {
      this.period = this.getPeriod
      if (!this.period || !this.period.from || !this.period.to) {
        // Период по умолчанию - текущий год
        this.period = {
          from: new Date(new Date().getFullYear(), 0, 1),
          to: new Date()
        }
      }
      this.datepickerPeriod = [
        this.period.from,
        this.period.to
      ]
      this.updatePeriod(this.period)
    },
    /**
     * Сохраняет новое значение периода в store
     * @param period
     */
    updatePeriod (period) {
      this.setPeriod(period)
    },
    /**
     * Сохраняет новое значение периода из Datepicker в store
     * @param period
     */
    updatePeriodFromDatePicker (period) {
      this.updatePeriod({
        from: period[0],
        to: period[1]
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../../../../resources/css/variables';

#tabs-header .nav-item button {
  padding-left: 40px;
  padding-right: 40px;
  margin-right: 10px;
}

#tabs-header .nav-item button.btn-danger {
  color: #fff !important;
  background-color: #d71c3a;
}

#tabs-body {
  margin-top: 30px;
}

#tabs-body .box {
  overflow-x: auto;
}

.flex-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.flex-col {
  &:first-child {
    padding-right: 15px;
  }
  @media all and (max-width: $xsBreakpoint - 1) {
    & {
      margin-bottom: 10px;
      padding-right: 0;
      flex-basis: 100%;
      .nav-item {
        margin: 0;
        button {
          margin-bottom: 5px;
        }
      }
    }
  }
}
</style>
